import { isHapticSuppressed } from '../utils/haptics';
import {
  close,
  getUser,
  haptic,
  isHostAvailable,
  showAlert,
  showConfirm,
  showPopup,
} from '../platform';

export const useTelegram = () => {
  const hapticFeedback = (type = 'medium') => {
    if (!isHapticSuppressed()) haptic(type);
  };

  return {
    isAvailable: isHostAvailable(),
    user: getUser(),
    showAlert,
    showConfirm,
    showPopup,
    hapticFeedback,
    close
  };
};
